import { DisplaySize, ROUTES } from "@lhd/constants";
import { Container, Item } from "./styled";
import { useEffect } from "react";
import { Tooltip } from "antd";
import { useGetPermissionsEachPage } from "@lhd/hooks";
import { MODE } from "@lhd/types";
import { useMatch } from "react-router-dom";

interface Option {
  label: string;
  value: string;
  disabled?: boolean;
}

interface Props {
  options: Option[];
  value?: string;
  onChange?: (value: string) => void;
  displaySize?: DisplaySize;
  disabled?: boolean;
  forceValue?: any;
  listModeDevelop?: any[];
}

export default function SegmentedControl({
  options,
  value,
  onChange,
  displaySize = "small",
  disabled = false,
  forceValue,
  listModeDevelop,
}: Props) {
  const permissionsEachPage = useGetPermissionsEachPage();

  const isBusinessManuals = Boolean(useMatch(`/${ROUTES.BUSINESS_MANUALS}/*`));
  const matchBusinessManualsEdit = useMatch(
    `/${ROUTES.BUSINESS_MANUALS}/:appId/edit/:id`,
  );
  const isBusinessManualsViewInNewTab = Boolean(matchBusinessManualsEdit);

  useEffect(() => {
    if (forceValue || value) {
      onChange && onChange(forceValue || value);
    }
  }, [forceValue, value]);

  return (
    <Container $displaySize={displaySize} $disabled={disabled}>
      {options.map((item) => {
        const isDevelop = listModeDevelop?.includes(item.value);
        const isBusinessManualsEditDisabled =
          isBusinessManuals && item.value === MODE.EDIT;

        return (
          <Tooltip
            key={item.value}
            open={isDevelop ? undefined : false}
            title={
              isBusinessManuals && item.value !== "edit_layout"
                ? "権限がありません"
                : "開発中"
            }
            color={
              isBusinessManualsEditDisabled || isBusinessManualsViewInNewTab
                ? "#141414"
                : "#6BC77A"
            }
          >
            <div>
              <Item
                className="non_css"
                key={item.value}
                active={item.value === (forceValue || value)}
                disabled={disabled || item.disabled || !!isDevelop}
                onClick={(e) => {
                  e.preventDefault();
                  if (disabled) return;
                  onChange && onChange(forceValue || item.value);
                }}
                $displaySize={displaySize}
              >
                {item.label}
              </Item>
            </div>
          </Tooltip>
        );
      })}
    </Container>
  );
}
